import React, { Component } from 'react';
import { Button, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import './component/all.css'
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import globalService from "./utils";
import Routes from './router'
import logo from './img/logo.png'
import { Popconfirm } from 'antd';

const { sessionManage, } = globalService

class App extends Component {
    constructor(props) {
        super(props)
        // init locales

        this.state = {
            collapsed: false,
            current: sessionManage.getItem('current') || '/home',
            mobile: sessionManage.getItem('mobile'),
        }
    }

    onCollapse = collapsed => {
        this.setState({ collapsed });
        sessionManage.setItem('collapsed', collapsed)
    };

    onSelectLocale = lang => {
        localStorage.setItem('lang_type', lang);
        // reload page
        window.location.reload();
    };

    handleClick = current => {
        this.setState({ current });
        sessionManage.setItem('current', current)
    };

    handleLogout = () => {
        sessionManage.removeItem('mobile');
        window.location.reload();
    }

    render() {
        const { current, mobile } = this.state;
        return (
            <div style={{ background: '#F6F6F6' }}>
                <Navbar expand="lg" variant="dark" bg='dark' onSelect={this.handleClick}>
                    <Navbar.Brand href="#home" className='sys_title'>
                        <img alt='logo' src={logo} style={{ width: '40px' }} />   {window.config.title}
                        {/*一个健康生活的态度和方法*/}

                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto" activeKey={current}>
                            <Nav.Link href="/home">首页</Nav.Link>
                            <Nav.Link href="/news2">润脉咨询（收费）</Nav.Link>

                            {/* <Nav.Link href="/news">资讯动态</Nav.Link> */}
                            {/* <NavDropdown title="面向专业人士" id="basic-nav-dropdown">
                                    <NavDropdown.Item href="/consult" >润脉咨询师</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown title="面向家庭" id="basic-nav-dropdown">
                                    <NavDropdown.Item href="/healthy">健康评估服务</NavDropdown.Item>
                                    <NavDropdown.Item href="/rFConditioning">润方调理服务</NavDropdown.Item>
                                    <NavDropdown.Item href="/testRFConditioning">检测与调理服务</NavDropdown.Item>
                                </NavDropdown> */}
                            <NavDropdown title="关于我们" id="basic-nav-dropdown">
                                {/* <NavDropdown.Item href="/aboutService">全球服务网络</NavDropdown.Item> */}
                                <NavDropdown.Item href="/aboutIntroduce">润脉技术介绍</NavDropdown.Item>
                                <NavDropdown.Item href="/contact">联系我们</NavDropdown.Item>
                            </NavDropdown>
                            {
                                !!mobile
                                    ? <Popconfirm placement="bottom" title="退出登录？"
                                        okText="确定" cancelText="取消" onConfirm={this.handleLogout}>
                                        <Button size='sm' variant="primary" color='danger'>欢迎 {mobile}</Button>
                                    </Popconfirm>
                                    : <Nav.Link href="/session">登录注册</Nav.Link>
                            }
                        </Nav>
                    </Navbar.Collapse>
                    {/* <Navbar.Brand className='sys_title'>
                            400-102-2771
                        </Navbar.Brand> */}
                </Navbar>
                <div style={{ height: document.body.clientHeight - 72 + 'px', overflowY: 'auto' }} >
                    <Routes />
                </div>
            </div>
        );
    }
}

export default App;





